import * as $ from "jquery";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
$.fn.datepicker.defaults.format = "yyyy-mm-dd";
export default (function() {
  $(".start-date")
    .datepicker({
      autoclose: true,
      orientation: "left"
    })
    .attr("autocomplete", "off");
  $(".end-date").datepicker();
})();
